import { Card, Col, Row, Spinner } from "react-bootstrap"
import { useTranslation } from "react-i18next"

interface DashboardData {
  total: number
  newCount: number
  underReview: number
  resolved: number
}

interface Props {
  data: DashboardData | null
  isLoading: boolean
}

const KPICard = ({ title, value, color, icon }: { title: string; value: number; color: string; icon: string }) => (
  <Col xs={6} md={3}>
    <Card className="text-center mb-3 border-0 shadow-sm">
      <Card.Body className="py-3">
        <div style={{ color }} className="mb-1">
          <i className={`fas ${icon} fa-2x`} />
        </div>
        <h3 className="mb-0 fw-bold">{value}</h3>
        <small className="text-muted">{title}</small>
      </Card.Body>
    </Card>
  </Col>
)

const IncidentKPICards = ({ data, isLoading }: Props) => {
  const { t } = useTranslation("global")

  if (isLoading) return <div className="text-center py-3"><Spinner animation="border" size="sm" /></div>
  if (!data) return null

  return (
    <Row className="mb-2">
      <KPICard title={t("Total incidencias")} value={data.total} color="#6c757d" icon="fa-triangle-exclamation" />
      <KPICard title={t("Nuevas")} value={data.newCount} color="#ffc107" icon="fa-circle-exclamation" />
      <KPICard title={t("En revisión")} value={data.underReview} color="#0dcaf0" icon="fa-magnifying-glass" />
      <KPICard title={t("Resueltas")} value={data.resolved} color="#198754" icon="fa-circle-check" />
    </Row>
  )
}

export default IncidentKPICards
